{
  "#PDF_VIEWER": {
    "NO_DOCUMENT": "Es ist kein Dokument zum Anzeigen vorhanden"
  }
}
